export default {
    SET_CUSTOMERS(state, customers) {
        state.loading = false
    },
    FETCH_CUSTOMERS(state) {
        state.loading = true
    },
    ADD_WORKER(state, worker) {
        state.customers.unshift(worker)
    }
}